var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavPayouts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4802 1H3.52022C2.13054 1 1.00018 2.13035 1.00018 3.52003V5.01017C1.00018 5.34164 1.26871 5.61017 1.60018 5.61017C1.93166 5.61017 2.20018 5.34164 2.20018 5.01017V3.52003C2.20018 2.79215 2.79229 2.2 3.52022 2.2H22.4802C23.2079 2.2 23.8002 2.79211 23.8002 3.52003V14.4799C23.8002 15.2076 23.2079 15.7999 22.4802 15.7999H3.52022C2.79234 15.7999 2.20018 15.2076 2.20018 14.4799V9.59973H16.5916L14.2158 11.9755C13.9813 12.21 13.9813 12.5897 14.2158 12.8239C14.333 12.9411 14.4865 12.9995 14.6402 12.9995C14.7939 12.9995 14.9472 12.9409 15.0646 12.8239L18.4647 9.4238C18.5765 9.31147 18.64 9.15879 18.64 8.99975C18.64 8.84071 18.5767 8.68803 18.4644 8.57537L15.0641 5.17561C14.8295 4.94106 14.4499 4.94106 14.2156 5.17561C13.9811 5.40981 13.9811 5.78983 14.2156 6.02405L16.5914 8.39978H1.6C1.26852 8.39978 1 8.66831 1 8.99978C1 9.02037 1.00402 9.03962 1.00603 9.05971C1.00402 9.07963 1 9.09922 1 9.11981V14.4799C1 15.8696 2.13035 17 3.52003 17H22.48C23.8696 17 25 15.8696 25 14.4799V3.52012C25 2.13043 23.8696 1.00008 22.48 1.00008L22.4802 1Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPayouts);
export default __webpack_public_path__ + "static/media/NavPayouts.0945f1f164eafca0e5436dbaa01c6182.svg";
export { ForwardRef as ReactComponent };